import { useState, useEffect, useRef } from 'react';
import DateFunc from '@/lib/lyg/date_func';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import ArrFunc from '@/lib/lyg/arr_func';
import getXcolumnJson from "./xcolumn/list";
import SearchArea from "./area/search";
import ListArea from "./area/list";
import CustomListExcelDown from "./area/excel_down";

function MonthListArea(props: any) {
  let myProps = {
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const CustomListExcelDownRef=useRef<any>();
  const xColumnArr = getXcolumnJson();
  const [listOpt, setListOpt] = useState({
    s_mcomp_seq: "",
    s_date_type: "a_date",
    s_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
    s_end_date: DateFunc.get_date_format(new Date(), "Y-m-t"),
    group_id: "a_stu_seq",
    s_user_name_like: "",
    is_paging: "",

    is_month_group_search: "1",
    is_addon_user: "1",

    order_key: "row_tot_star",
    up_down: "down",
  });
  const [infoArr, setInfoArr] = useState([]);

  useEffect(() => {
    list({});
  }, [user.comp_seq]);

  const list = (inData: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inData,
    };

    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }

    tmp_list_opt.s_mcomp_seq = user.comp_seq;
    setListOpt(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo_dailyc/list', tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          response.data["data"]["info_arr"]=set_order_info_arr_by_key({
            order_key: tmp_list_opt.order_key,
            up_down: tmp_list_opt.up_down,
            infoArr: response.data["data"]["info_arr"],
          });
          setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const set_order_info_arr_by_key = (inData: any) => {
    let opt_obj = {
      order_key: listOpt.order_key,
      up_down: listOpt.up_down,
      infoArr: infoArr,
      ...inData
    };
    let order_key = opt_obj.order_key;
    let tmp_info_arr: any = ArrFunc.get_ordered_json_arr_by_key({
      arr: opt_obj.infoArr,
      key_arr: [order_key],
      is_number_key:true,
    });

    if(opt_obj.up_down==="down"){
      tmp_info_arr=tmp_info_arr.reverse();
    }
    return tmp_info_arr;
  };

  const go_excel_down=()=>{
    if(CustomListExcelDownRef.current){
      CustomListExcelDownRef.current.goExcelDown({});
    }
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        list={list}
        go_excel_down={go_excel_down}
      ></SearchArea>
      <div className='mt-1'>
        <ListArea
          xColumnArr={xColumnArr}
          infoArr={infoArr}
          listOpt={listOpt}
          list={list}
        ></ListArea>
      </div>
      <CustomListExcelDown
        ref={CustomListExcelDownRef}
        xColumnArr={xColumnArr}
        infoArr={infoArr}
      ></CustomListExcelDown>
    </div>
  );
};
export default MonthListArea;